import { Accordion, styled } from '@mui/material';

export const StyledAccordion = styled(Accordion)({
  '&.MuiPaper-root': {
    borderRadius: '8px',
    border: '1px solid',
    boxShadow: 'none',
  },
});
